// extracted by mini-css-extract-plugin
export default {"headerButton":"Dialog_headerButton__1Tj73","deleteButton":"Dialog_deleteButton__Sbv-G"};